import { LoadingContainer } from 'peach/components'
import { useHistory, useParams } from 'peach/router'
import { useQueryClient } from '@tanstack/react-query'

import { DynamicForm, Page, PageHeader } from 'core/components'
import { useCompanyAppDomainPost } from 'core/types'
import type { CompanyAppDomain } from 'core/types'

const CreateAppDomain = () => {
  const history = useHistory()
  const { companyId } = useParams<{ companyId?: string }>()

  const queryClient = useQueryClient()

  const { mutateAsync: createAppDomain } = useCompanyAppDomainPost({
    companyId,
  })

  return (
    <LoadingContainer>
      <Page variant='full'>
        <PageHeader title='Create App Domain' />
        <DynamicForm
          data={{
            domain: undefined,
            type: undefined,
          }}
          fieldEditMode='all'
          fieldOverrides={{
            type: 'Select',
          }}
          omitFields={['id', 'companyId']}
          onSubmit={async (payload: any) => {
            const res = (await createAppDomain(
              payload as CompanyAppDomain,
            )) as unknown as {
              status: number
              data: CompanyAppDomain
            }
            const data = res?.data
            if (data?.id) {
              void queryClient.invalidateQueries({
                queryKey: ['companies', companyId, 'app-domains'],
              })
              history.push(`/companies/${companyId}/app-domains/${data.id}`)
            }
          }}
          selectOptions={{
            type: [
              { label: 'Borrower', value: 'borrower' },
              { label: 'Agent', value: 'agent' },
              { label: 'Help', value: 'help' },
              { label: 'Admin', value: 'admin' },
            ],
          }}
          submitText='Create App Domain'
          validationRules={{
            domain: [
              (v: unknown) =>
                (typeof v === 'string' && v.trim().length > 0) ||
                'Domain is required',
            ],
            type: [
              (v: unknown) =>
                (typeof v === 'string' && v.trim().length > 0) ||
                'Type is required',
            ],
          }}
        />
      </Page>
    </LoadingContainer>
  )
}

export default CreateAppDomain
